import { useState, useEffect } from 'react'
import DataTable from '../components/DataTable'
import { KTSVG } from '../../_metronic/helpers'
import 'react-loading-skeleton/dist/skeleton.css'
import { getRequestOptions } from '../helpers/Fetchwrapper'
import Select from 'react-select'
import GetPagePermission from '../components/GetPagePermission'
import Error from '../components/Error500'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

function PendingDeliveries() {
    const hasPermission = GetPagePermission('/pending-deliveries')
    const [selectProjectOptions, setSelectProjectOptions] = useState([])
    const [project, setProject] = useState({ label: 'Select Project', value: '' })
    const [additionalPostData, setAdditionalPostData] = useState({ idProjects: '' })

    const handleProjectChange = (selectedProject: any) => {
        setProject(selectedProject)
    }

    const getProjectList = async () => {
        const url = process.env.REACT_APP_API_URL + 'projects'
        const response = await fetch(url, getRequestOptions())
        const data = await response.json()

        data.data.map((element: any) => {
            element.value = element.id_projects
            element.label = element.project_name
            return element
        })

        if (data.data.length === 1) {
            setSelectProjectOptions(data.data)
        } else {
            const allProjectsOpt = [{ id: '', name: '', label: 'All Project', value: '' }]
            setSelectProjectOptions(data.data.concat(allProjectsOpt))
        }
    }

    useEffect(() => {
        getProjectList()
    }, [])

    useEffect(() => {
        if (selectProjectOptions.length === 1) {
            setProject({ label: selectProjectOptions[0]['label'], value: selectProjectOptions[0]['value'] })
        }
    }, [selectProjectOptions])

    useEffect(() => {
        setAdditionalPostData({ idProjects: project.value })
    }, [project])

    const columns = [
        { value: 'id', title: 'ID', style: { textAlign: 'center' } },
        {
            value: 'salesOrderId',
            title: 'Sales Order ID',
            style: { textAlign: 'center' },
            hasHtmlComponent: true,
            htmlComponent: (rowValue: any) => {
                return (
                    <>
                        {rowValue.id ? <a href={'/#/sales-order/' + rowValue.id}>{rowValue.salesOrderId}</a> : ''}
                    </>
                )
            },
        },
        { value: 'salesQuotation', title: 'Quotation', style: { textAlign: 'center' } },
        { value: 'projectName', title: 'Project', style: { textAlign: 'center' } },
        { value: 'srName', title: 'SR', style: { textAlign: 'left' } },
        { value: 'companyName', title: 'Client', style: { textAlign: 'left' } },
        { value: 'orderDate', title: 'Date', style: { textAlign: 'left' } },
        { value: 'creditDays', title: 'Credit Days', style: { textAlign: 'left' } },
        { value: 'createdBy', title: 'Created By', style: { textAlign: 'left' } },
        { value: 'status', title: 'Status', style: { textAlign: 'center' } },
        { value: 'shipmentCount', title: 'Shipment Count', style: { textAlign: 'center' } },
    ]

    const filters = {
        id: { filterType: 'like', filterValue: '' },
        salesOrderId: { filterType: 'like', filterValue: '' },
        projectName: { filterType: 'like', filterValue: '' },
        salesQuotation: { filterType: 'like', filterValue: '' },
        srName: { filterType: 'like', filterValue: '' },
        companyName: { filterType: 'like', filterValue: '' },
        orderDate: { filterType: 'like', filterValue: '' },
        creditDays: { filterType: 'like', filterValue: '' },
        createdBy: { filterType: 'like', filterValue: '' },
        status: { filterType: 'like', filterValue: '' },
        shipmentCount: { filterType: 'like', filterValue: '' },
    }

    const url = process.env.REACT_APP_API_URL + 'pending-deliveries/dt'

    return (
        <>
            {hasPermission === 1 && (
                <div className="card card-custom">
                    <div className="card-header">
                        <div className="card-title">
                            <KTSVG path="/media/svg/icons/Text/Bullet-list.svg" className="svg-icon-1 svg-icon-primary" />
                            <span className="text fw-bolder" style={{ marginLeft: '10px' }}>
                                Pending Deliveries
                            </span>
                        </div>
                        <div className="card-toolbar">
                            <div className="d-flex justify-content-end">
                                <Select
                                    onChange={handleProjectChange}
                                    options={selectProjectOptions}
                                    placeholder={project.label}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="card-body">
                        <DataTable url={url} columns={columns} filters={filters} additionalPostData={additionalPostData} />
                    </div>
                </div>
            )}

            {hasPermission === 0 && <Error />}
            {hasPermission === '' && (
                <div className="card card-custom" style={{ padding: '15px' }}>
                    <SkeletonTheme>
                        <p>
                            <Skeleton containerClassName="avatar-skeleton" count={40}></Skeleton>
                        </p>
                    </SkeletonTheme>
                </div>
            )}
        </>
    )
}

export default PendingDeliveries
